/* eslint-disable import/prefer-default-export */
export const getId = (url: string): string => {
  const newUrl = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

  return newUrl[2] ? newUrl[2].split(/[^0-9a-z_-]/i)[0] : newUrl[0];
};
